
export const keys = {
    public: process.env.STRIPE_PUBLISH_KEY
};
